export function getStockThresholdLabel(cnt: number): string {
    if (cnt <= 0) return 'Нет в наличии';
    if (cnt > 50) return 'более 50 шт.';
    return 'менее ' + (Math.ceil(cnt / 10) * 10) + ' шт.';
}

export function shouldShowMskStock(baseStockId: string | undefined, clientBaseStockId: string | undefined): boolean {
    return clientBaseStockId !== baseStockId;
}